import type { LogoAsset } from '../../../data/asset';
import { KalturaLogoAsset } from '../../composed';
import { processPhoenixImages } from '../../processing/processing';

export function processLogo(asset: KalturaLogoAsset): LogoAsset {
  return {
    id: asset.id,
    images: processPhoenixImages(asset.images),
    type: 'logo',
  };
}
